<template>
  <e-dialog ref="dialogRef" @update:modelValue="onDialogOpen">
    <template #activator>
      <slot name="activator">
        <e-btn icon variant="tonal">
          <e-icon name="options" />
        </e-btn>
      </slot>
    </template>
    <template #title>
      <e-icon class="mr-2" name="options" />
      <span class="caption"> Фильтр </span>
    </template>

    <slot :items="temporaryFilters as T" />

    <template #buttons>
      <e-btn variant="ghost" class="mx-2 mr-sm-auto" @click="resetFilters"> Сбросить</e-btn>
      <e-btn variant="secondary" @click="closeFiltersDialog"> Закрыть</e-btn>
      <e-btn variant="primary" @click="applyFilters"> Применить</e-btn>
    </template>
  </e-dialog>
</template>

<script setup lang="ts" generic="T extends Record<string, unknown>">
import { ref } from 'vue';
import type { IDialog } from '@/core/types/components/components';
import EDialog from '@/core/components/modals/Dialog.vue';
import { EBtn, EIcon } from '@/core/components/ui';
import { deepCloneObject } from '@/core/utils/object';

const props = defineProps<{
  modelValue: T;
  defaultFilters: () => T;
}>();

const emit = defineEmits<{
  (event: 'update:modelValue', value: T): void;
}>();

defineSlots<{
  default: (props: { items: T }) => void;
  activator?: (props: unknown) => void;
}>();

const temporaryFilters = ref<T>(props.defaultFilters());

const onDialogOpen = (isOpened: boolean | undefined) => {
  if (isOpened) {
    temporaryFilters.value = deepCloneObject(props.modelValue);
  }
};

const dialogRef = ref<IDialog>();

const resetFilters = () => {
  temporaryFilters.value = props.defaultFilters();
};

const closeFiltersDialog = () => {
  dialogRef.value?.close();
};

const applyFilters = () => {
  emit('update:modelValue', deepCloneObject(temporaryFilters.value) as T);
  closeFiltersDialog();
};
</script>

<style scoped lang="scss"></style>
